/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { Container } from '@material-ui/core';
import { getWindowDimensions } from '../../utils/dimension';

interface Props {
  children: any;
  component: any;
  maxWidth: any | false;
}

const ContainerComponent: React.FC<Props> = ({ children, component, maxWidth }) => {
  const [, setWindowDimensions] = useState(getWindowDimensions());
  // @ts-ignore

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Container
        component={component}
        children={children}
        maxWidth={maxWidth}
      />
    </>
  );
};
export default ContainerComponent;
